import { render, staticRenderFns } from "./NetworkPaper.vue?vue&type=template&id=9a79f152"
import script from "./NetworkPaper.vue?vue&type=script&lang=js"
export * from "./NetworkPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports